"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _axios = _interopRequireDefault(require("axios"));
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var _getNamespace = _interopRequireDefault(require("./getNamespace"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var enUS = _modalLoaderUtils.CONSTANTS.enUS;
var loadResource = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(i18nUrl, filename) {
    var resp;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _axios.default.get("".concat(i18nUrl).concat(filename, ".json"));
        case 2:
          resp = _context.sent;
          return _context.abrupt("return", resp.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadResource(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var loadMarket = function loadMarket(i18nUrl, market) {
  var lang = market.split('-')[0];
  return loadResource(i18nUrl, market).catch(function () {
    return (
      // TODO is this necessary?
      loadResource(i18nUrl, lang).catch(function () {
        return null;
      })
    );
  });
};
var loadContent = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(market, url) {
    var loaders, _yield$Promise$all, _yield$Promise$all2, enUsData, localeData;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          loaders = [loadResource(url, enUS)];
          if (market !== enUS) {
            loaders.push(loadMarket(url, market));
          }
          _context2.next = 4;
          return Promise.all(loaders);
        case 4:
          _yield$Promise$all = _context2.sent;
          _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
          enUsData = _yield$Promise$all2[0];
          localeData = _yield$Promise$all2[1];
          return _context2.abrupt("return", {
            market: market,
            messages: _objectSpread(_objectSpread({}, enUsData), localeData)
          });
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function loadContent(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = exports.default = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref3, appConfig, _ref4) {
    var i18nPath, i18nVersionKey, market, namespace, cdnUrl, isLocal, version, i18n, i18nVersion, buildVersion, path, url;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          i18nPath = _ref3.i18nPath, i18nVersionKey = _ref3.i18nVersionKey, market = _ref3.market, namespace = _ref3.namespace;
          cdnUrl = _ref4.cdnUrl, isLocal = _ref4.isLocal, version = _ref4.version;
          i18n = (0, _getNamespace.default)(namespace, 'i18n');
          if (!i18n[market]) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return", i18n[market]);
        case 5:
          i18nVersion = i18nVersionKey && appConfig[i18nVersionKey] || version;
          buildVersion = isLocal || !i18nVersion ? '' : "-".concat(i18nVersion);
          path = "/".concat(i18nPath).concat(buildVersion, "/").replace('//', '/');
          url = "".concat(cdnUrl).concat(path);
          _context3.next = 11;
          return loadContent(market, url);
        case 11:
          i18n[market] = _context3.sent;
          return _context3.abrupt("return", i18n[market]);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function (_x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();